<template>
    <Layout   style="overflow:hidden">
    <div  style="height:44px;"><Toolbar
      :items="tools"
      :height="40"
      v-model="toolValue"
       @on-event="handleToolEvent"
      :gap="3"
    /></div>

    <Layout style="max-width:100%;height:calc(100% - 44px)">

        <Content style="overflow-y:auto;background:#eee;height:calc(100%);max-width:100%;overflow:auto;">
          <UgoXForm
            ref="testform"
            :form="_form"
            style="padding:20px;margin:20px auto;min-width:375px;max-width:800px;" v-model="formData"
            @on-submit="handleSubmit"
            editable

          />

          </Content>
        <Sider :width="400"  style="border-left:1px solid #aaa;background:#fff;max-width:400px;padding:0;" v-if="toolValue.showSider">

          <pre style="margin:0;background:var(--border);height:100%;color:#aaa;padding:10px;">{{formData}}</pre>
        </Sider>
  </Layout>

  <Modal v-model="showCode" :width="800" title="本地代码">
    <pre  style="margin:0;background:var(--border);height:100%;color:#aaa;padding:10px;">
      {{ form }}
    </pre>
  </Modal>
  </Layout>
  </template>

<script>
import {cloneDeep} from 'lodash';
import UgoXForm from './view.vue';
import Toolbar from '@/components/app/toolbar';
export default {
  components: {UgoXForm, Toolbar},
  props: ['form'],
  watch: {
    form: {
      handler(v) {
        this._form = cloneDeep(v);
        this.formData = {};
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {},
      _form: {},
      showCode: false,
      toolValue: {showSider: true},
      tools: [{
        key: 'showSider',
        name: '组件栏',
        togglable: true,
        icon: 'md-list',
        type: 'icon-button',
      }, {
        key: 'code',
        name: '本地代码',
        icon: 'md-code',
        type: 'icon-button',
      }],
    };
  },
  methods: {
    handleToolEvent({type, key, value, data}) {
      const eventMap = {
        code: ()=>this.showCode = true,
      };

      const eventHandler = eventMap[key];
      if (eventHandler) {
        eventHandler(value);
      }
    },
    submit() {
      this.$refs.testform.submit();
    },
    handleSubmit(e) {
      console.log(e);
      this.formData=e;
    },
    exportTmpl() {
      this.$api.post('forms/gen-docx', {
        form_id: this.form.id,
        data: [this.formData],
      }).then((res)=>{
        const {url, name} = res.data.data;
        console.log(url, name);
        this.DownloadWithName(url, name);
      }).catch((e)=>{
        this.Error(e);
      });
    },
  },
};
</script>

  <style lang="scss" scoped>

  </style>
